import UniqueQuote from '../UniqueQuote/UniqueQuote';
import QuotePreview from './QuotePreview';

export default function BaseUniqueQuote({ readOnly = false }) {
    return readOnly ? <QuotePreview readOnly /> : <UniqueQuote />;
}
